import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import "datatables.net-dt/css/dataTables.dataTables.css";
import axios from "axios";
import Swal from "sweetalert2";
import { createMRTColumnHelper } from "material-react-table";

import { baseUrl } from "../../helper/urls.js";
import CustomTable from "../../components/custom_table/CustomTable.jsx";
import { Chip } from "@mui/material";
import { useSelector } from "react-redux";

const BookingListPage = () => {
  const { token } = useSelector((state) => state.auth);
  const [bookings, setBookings] = useState([]);

  // console.log("list:::::::::::::::::::::::", bookings);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const url = `${baseUrl}/bookings/byAdmin`;

  const fetchBookings = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };

      const response = await axios.get(url, { headers });
      // console.log("response:::::::::::::::::::::", response.data);

      setBookings(response.data.data || []);
      setLoading(false);
    } catch (error) {
      setError(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, []);

  const handleDelete = (id) => {
    Swal.fire({
      html: `<div style="font-size: 30px; font-weight: bold;">Are you sure?</div>`,
      text: "This will permanently delete the booking.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${url}/${id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then(() => {
            setBookings((prev) => prev.filter((item) => item.id !== id));
            fetchBookings();
            Swal.fire("Deleted!", "Booking has been deleted.", "success");
          })
          .catch((error) => {
            console.error("Error deleting booking:", error);
            const message =
              error.response?.data?.message ||
              error.message ||
              "Failed to delete booking.";
            Swal.fire("Error", message, "error");
          });
      }
    });
  };

  const handleEdit = (booking) => {
    navigate("/bookings", { state: { booking } });
  };

  const statusMap = {
    0: "Pending",
    1: "Accepted",
    2: "Paid",
    3: "Rejected",
    4: "Upcoming",
    5: "Completed",
  };

  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("id", {
      header: "ID",
      size: 30,
    }),
    columnHelper.accessor("student_id", {
      header: "Student Name",
      size: 30,
      Cell: (cell) =>
        cell.row.original?.firstName + " " + cell.row.original?.lastName,
    }),
    columnHelper.accessor("counselor_id", {
      header: "Counselor Name",
      size: 30,
      Cell: (cell) =>
        cell.row.original?.c_firstname + " " + cell.row.original?.c_lastname,
    }),
    // columnHelper.accessor("slot_id", {
    //   header: "Slot ID",
    //   size: 30,
    // }),
    columnHelper.accessor("booking_date", {
      header: "Booking Date",
      size: 30,
      Cell: (cell) => cell.row.original.booking_date?.split("T")[0] || "N/A",
    }),
    columnHelper.accessor("booking_time", {
      header: "Booking Time",
      size: 30,
    }),
    columnHelper.accessor("booking_duration", {
      header: "Duration (min)",
      size: 30,
    }),
    // columnHelper.accessor("status", {
    //   header: "Status",
    //   size: 30,
    //   cell: ({ cell }) => {
    //     const status = cell.row.original.status;
    //     // console.log("data:::::::::::::;;", status);
    //     return statusMap[status] || "Unknown";
    //   },
    // }),

    columnHelper.accessor("status", {
      header: "Status",
      size: 30,
      Cell: (cell) => {
        const status = cell.row.original.status;
        return statusMap[status] || "Unknown";
      },
    }),

    // columnHelper.accessor("is_deleted", {
    //   header: "Deleted",
    //   size: 30,
    //   Cell: (cell) => (cell.row.original?.status === 1 ? "Yes" : "No"),
    // }),
    // columnHelper.accessor("created_at", {
    //   header: "Created At",
    //   size: 30,
    //   cell: ({ getValue }) => getValue()?.split("T")[0] || "N/A",
    // }),
    // columnHelper.accessor("updated_at", {
    //   header: "Updated At",
    //   size: 30,
    //   cell: ({ getValue }) => getValue()?.split("T")[0] || "N/A",
    // }),
    // columnHelper.accessor('actions', {
    //   header: 'Actions',
    //   size: 30,
    //   cell: ({ row }) => {
    //     const rowData = row.original;

    //     return (
    //       <Box>
    //         <button
    //           onClick={() => handleEdit(rowData)}
    //           className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
    //         >
    //           <Icon icon="lucide:edit" />
    //         </button>

    //         <button
    //           onClick={() => handleDelete(rowData.id)}
    //           className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
    //           style={{ cursor: 'pointer' }}
    //         >
    //           <Icon icon="mingcute:delete-2-line" />
    //         </button>
    //       </Box>
    //     );
    //   },
    // }),
  ];

  return (
    // <div className="card basic-data-table">
    //   <div className="card-body">
    //     <table
    //       className="table bordered-table mb-0"
    //       id="dataTable"
    //       data-page-length={5}
    //     >
    //       <thead>
    //         <tr>
    //           <th>S.No</th>
    //           <th>Student ID</th>
    //           <th>Counselor ID</th>
    //           <th>Slot ID</th>
    //           <th>Booking Date</th>
    //           <th>Time</th>
    //           <th>Duration (min)</th>
    //           <th>Status</th>
    //           {/* <th>Actions</th> */}
    //         </tr>
    //       </thead>
    //       <tbody>
    //         {bookings?.map((booking, index) => (
    //           <tr key={booking.id}>
    //             <td>{index + 1}</td>
    //             <td>{booking.student_id}</td>
    //             <td>{booking.counselor_id}</td>
    //             <td>{booking.slot_id}</td>
    //             <td>{booking.booking_date.split("T")[0]}</td>
    //             <td>{booking.booking_time}</td>
    //             <td>{booking.booking_duration}</td>
    //             {/* <td>{booking.status === 0 ? "Pending" : "Confirmed"}</td> */}
    //             <td>{statusMap[booking.status] || "Unknown"}</td>
    //             {/* <td>
    //               <button
    //                 onClick={() => handleEdit(booking)}
    //                 className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
    //               >
    //                 <Icon icon="lucide:edit" />
    //               </button>
    //               <button
    //                 onClick={() => handleDelete(booking.id)}
    //                 className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
    //                 style={{ cursor: "pointer" }}
    //               >
    //                 <Icon icon="mingcute:delete-2-line" />
    //               </button>
    //             </td> */}
    //           </tr>
    //         ))}
    //       </tbody>
    //     </table>
    //   </div>
    // </div>

    <CustomTable columns={columns} data={bookings} loading={loading} />
  );
};

export default BookingListPage;
